import { render, staticRenderFns } from "./InvitePersonDlg.vue?vue&type=template&id=2cfc8101&scoped=true"
import script from "./InvitePersonDlg.vue?vue&type=script&lang=js"
export * from "./InvitePersonDlg.vue?vue&type=script&lang=js"
import style0 from "./InvitePersonDlg.vue?vue&type=style&index=0&id=2cfc8101&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfc8101",
  null
  
)

export default component.exports